module.exports = __webpack_public_path__ + "img/energy_juecezhichi.4ce50a6e.png";